import { overloadOption } from '@simplisafe/ewok'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'

export function overloadedOption<T>(t?: T | null | undefined) {
  return pipe(t, O.fromNullable, overloadOption)
}
